import ApiBudgety from '@/api/apiBudgety'

export const estadoMovimientoService = {
  getEstadoMovimiento,
}

async function getEstadoMovimiento() {
  return await ApiBudgety.get('EstadoMovimiento/GetAll')
}
